"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAssistChip = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AssistChipMixin = require("../../mixins/components/AssistChipMixin");
var _Button = require("../Button/Button");
var StyledAssistChip = /*#__PURE__*/(0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "StyledAssistChip",
  componentId: "c11n-8-107-0__sc-1gr17jv-0"
})(["", ""], _AssistChipMixin.AssistChipMixin);
exports.StyledAssistChip = StyledAssistChip;